<template>
    <div>
        <div class="d-flex h-100 w-100">
            <div class="col-md-3">
                <searchReports @search="formSearch = $event" @contapatologia="contapatologia = $event"></searchReports>
            </div>
            <div class="col-md-9">
                <chartReports :formSearch="formSearch" :contapatologia="contapatologia"></chartReports>
            </div>
        </div>
    </div>
</template>

<script>
import Reports from '../reports/reports.js'
export default Reports
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/reports/reports.vue